
export class ReporterWaiting extends Phaser.Group {

    private armImage: Phaser.Image;
    private reporterKnockingImage: Phaser.Image;
    private reporterWaiting: Phaser.Image;
    private doorImage: Phaser.Image;
    private reporterContainer: Phaser.Group;
    private knockingTimerEvent: Phaser.TimerEvent;

    constructor(game: Phaser.Game) {

        super(game, null, "reporter-waiting", false);

        this.reporterContainer = new Phaser.Group(this.game);
        this.reporterContainer.x = 260;
        this.reporterContainer.y = 400;
        this.add(this.reporterContainer);

        this.doorImage = new Phaser.Image(this.game, 150, 85, "texture_atlas_5", "loading_puerta");
        this.reporterContainer.add(this.doorImage);

        this.armImage = new Phaser.Image(this.game, 120, 180, "texture_atlas_5", "loading_brazo");
        this.armImage.anchor.set(.15, .85);
        this.reporterContainer.add(this.armImage);

        this.reporterKnockingImage = new Phaser.Image(this.game, 0, 100, "texture_atlas_5", "loading_speaker");
        this.reporterContainer.add(this.reporterKnockingImage);

        this.reporterWaiting = new Phaser.Image(this.game, 0, 100, "texture_atlas_5", "loading_speaker_2");
        this.reporterWaiting.visible = false;
        this.reporterContainer.add(this.reporterWaiting);

        this.game.add.tween(this.armImage)
            .to({ angle: 25 }, 600, Phaser.Easing.Bounce.Out)
            .to({ angle: 0 }, 400, Phaser.Easing.Cubic.Out)
            .start();

        // no llamaba al callback al terminar el ultimo tween sino el primero
        this.knockingTimerEvent = this.game.time.events.add(1200, this.knockAgain, this);
    }

    public destroy(destroyChildren?: boolean, soft?: boolean): void {

        if (this.knockingTimerEvent !== null) {
            this.knockingTimerEvent.pendingDelete = true;
        }

        super.destroy(destroyChildren, soft);
    }

    private knockAgain(): void {

        if (Math.random() > .65) {

            this.armImage.visible = false;
            this.reporterKnockingImage.visible = false;
            this.reporterWaiting.visible = true;

        } else {

            this.armImage.visible = true;
            this.reporterKnockingImage.visible = true;
            this.reporterWaiting.visible = false;

            this.game.add.tween(this.armImage)
                .to({ angle: 25 }, 600, Phaser.Easing.Bounce.Out)
                .to({ angle: 0 }, 400, Phaser.Easing.Cubic.Out)
                .start();
        }

        this.knockingTimerEvent = this.game.time.events.add(1000 + 1000 * Math.random(), this.knockAgain, this);
    }
}
